import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import messages from './HistoryView.intl';

import styles from './HistoryView.module.scss';

import { Container, Title } from 'common/components/Layout/Layout';
import StoryBox from './components/StoryBox/StoryBox';
import Timeline from './components/Timeline/Timeline';

import HistoriesStore from 'stores/Histories.store';
import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import { LOAD_STATES } from 'common/consts/common';
import Placeholder from 'common/components/Placeholder/Placeholder';
import StoryBoxPlaceholder from './placeholder/StoryBox/StoryBoxPlaceholder';

@injectIntl
@observer
class HistoryView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadState: LOAD_STATES.LOADING
    };
  }

  componentDidMount() {
    this.fetchHistories();
  }

  render() {
    const { histories } = HistoriesStore;
    return (
      <div className={styles.HistoryView}>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.historySEO} />
        )}
        <Container className={styles.MainHeading}>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Container className={styles.ContentWrapper}>
          <Placeholder
            component={<StoryBoxPlaceholder />}
            repeat={3}
            ready={this.isLoaded()}
          >
            <Timeline>
              {this.isLoaded() &&
                histories.map((history, i) => (
                  <StoryBox key={history.system.id} data={history} />
                ))}
            </Timeline>
          </Placeholder>
        </Container>
      </div>
    );
  }

  async fetchHistories() {
    await HistoriesStore.fetchHistories();
    this.setState({ loadState: LOAD_STATES.LOADED });
  }

  isLoaded() {
    return this.state.loadState === LOAD_STATES.LOADED;
  }
}

export default HistoryView;



// WEBPACK FOOTER //
// ./src/views/History/HistoryView.js